/**
 * Glass cards section — reveal only.
 *
 * @package HelloElementorChild
 */

import { initCamstReveal, teardownCamstReveal } from './camst-reveal.js';

export function initCamstGlassCards(scope) {
  var roots = [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-glass-cards]'));
  } else if (scope.matches && scope.matches('[data-camst-glass-cards]')) {
    roots = [scope];
  } else {
    roots = Array.prototype.slice.call(scope.querySelectorAll('[data-camst-glass-cards]'));
  }

  roots.forEach(function (root) {
    if (root.dataset.camstGlassCardsInit === '1') {
      return;
    }

    root.dataset.camstGlassCardsInit = '1';
    initCamstReveal(root);
  });
}

export function teardownCamstGlassCards(scope) {
  if (!scope) {
    return;
  }

  var roots = scope.matches && scope.matches('[data-camst-glass-cards]')
    ? [scope]
    : Array.prototype.slice.call(scope.querySelectorAll('[data-camst-glass-cards]'));

  roots.forEach(function (root) {
    teardownCamstReveal(root);
    delete root.dataset.camstGlassCardsInit;
  });
}
